import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2jx35qq7q6: FaireBrandEntity = {
  token: "b_2jx35qq7q6",
  type: "brand",
  name: "Midwest Fresh",
  avatarUrl:
    "https://cdn.faire.com/fastly/8464f19e23e7994418a36bb6639e4aea234c9dc2ec888bf0ab00e420cae8aa7a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/472e7d8d4c640e66f80f84781c3c57d91fa510251c6a6f1c760505f95add9cef.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8464f19e23e7994418a36bb6639e4aea234c9dc2ec888bf0ab00e420cae8aa7a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/472e7d8d4c640e66f80f84781c3c57d91fa510251c6a6f1c760505f95add9cef.png",
  location: "Marion, IN, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 148,
  isInsider: true,
  description:
    "Midwest Fresh started as a restaurant consulting company by Chef Kevin Grider. Armed with his arsenal of signature sauces and exquisite dish recipes, he was able to achieve several successful restaurant openings and revitalizations'. During his tenure as a consultant, Chef Kevin realized his signature recipes had the potential to be household brand names. He immediately began bottling sauces using real ingredients from Indiana, and selling them to retailers across the state of Indiana.\n\nWithin six months, his dream of building his company into a legitimate brand had come to fruition as orders began surge. Stores across the region began filling their shelves with his delicious sauces, and within a year a handful of distributors had helped Midwest Fresh grow to over 300 store locations. Kevin's dream continues today as Midwest Fresh is positioned to become a staple in homes across the Midwest and beyond.\n\nMidwest Fresh offers unique and delicious products ranging from our best selling Bacon Jam to the Tomato 2.0 pizza sauce that will change your life. Our extraordinary sauces have been adored by consumers and retailers alike. As one of the fastest growing brands in the Midwest, we are focused on the demands of a market that yearns for exclusive products sourced from high quality food producers, and we continue to craft our specialty foods to suit those needs.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:45.339Z",
    importedBy: "entity-db-cli",
  },
};
